import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedOption: null,
  selectedSite: null,
  selectedSiteOption: null,
  dataInfoId: null,
  allSites: [],
  siteData: [],
  dataSchema: null,
};

const truInkSlice = createSlice({
  name: "truInk",
  initialState,
  reducers: {
    setTruInkSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    setTruInkSelectedOptionLogout: (state) => {
      state.selectedOption = null;
    },
    setTruInkSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setTruInkSelectedSiteLogout: (state) => {
      state.selectedSite = null;
    },
    setTruInkSelectedSiteOption: (state, action) => {
      state.selectedSiteOption = action.payload;
    },
    setTruInkSelectedSiteOptionLogout: (state) => {
      state.selectedSiteOption = null;
    },
    setTruInkAllSites: (state, action) => {
      state.allSites = action.payload;
    },

    setTruInkDataInfoId: (state, action) => {
      state.dataInfoId = action.payload;
    },
    setTruInkDataInfoIdLogout: (state) => {
      state.dataInfoId = null;
    },
    setTruInkStateFromSessionStorage: (state, action) => {
      const { selectedOption, selectedSite, selectedSiteOption, allSites } =
        action.payload;
      state.selectedOption = selectedOption || null;
      state.selectedSite = selectedSite || null;
      state.selectedSiteOption = selectedSiteOption || null;
      state.allSites = allSites || [];
    },
    setSiteSchema: (state, action) => {
      // payload = { schema }
      state.siteSchema = action.payload.schema;
    },

    clearSiteSchema: (state) => {
      state.siteSchema = null;
    }
  },
});

export const {
  setTruInkSelectedOption,
  setTruInkStateFromSessionStorage,
  setTruInkSelectedOptionLogout,
  setTruInkSelectedSite,
  setTruInkSelectedSiteLogout,
  setTruInkSelectedSiteOption,
  setTruInkSelectedSiteOptionLogout,
  setTruInkAllSites,
  setTruInkDataInfoIdLogout,
  setTruInkDataInfoId,
  setSiteSchema,
  clearSiteSchema
} = truInkSlice.actions;

export default truInkSlice.reducer;
